import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import { landingSlug } from '../config/roles.js';

/**
 * Role-aware landing for the index route ('/').
 *
 * Replaces the hard-coded redirect to the admin-gated member dashboard (which
 * sent every non-admin user to a 403). Sends each authenticated user to their
 * role's home page; anonymous users to /login; a user with no provisioned page
 * to /403 (genuinely nothing to land on, rather than a spurious denial).
 */
export default function LandingRedirect() {
  const { user, isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="d-flex justify-content-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading…</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const slug = landingSlug(user);
  return <Navigate to={slug ? `/${slug}` : '/403'} replace />;
}
